import React, { Component } from 'react';
import TableListTh from './TableListTh';
import TableListTd from './TableListTd';

import './styles.css';

class TableList extends Component {
  static Th = TableListTh;
  static Td = TableListTd;

  render() {
    const { children } = this.props;

    return (
      <div className="TableList">
        <table className="TableList__table">{children}</table>
      </div>
    );
  }
}

export default TableList;
